import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { FiEdit } from "react-icons/fi";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { MdDelete, MdPrint } from "react-icons/md";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { checkAcessRights, formatIndianNumber } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  FINANCIAL_YEAR,
  INSERT_ACCESS,
  PRINT_ACCESS,
} from "../../_contstants/common";
import {
  deleteCreditNote,
  getAllCreditNote,
} from "./services/creditNote.services";
import {
  clearFilterCustomCreditNote,
  clearCreditNoteID,
  // setFilterCustomCreditNote,
  setCreditNoteID,
} from "./creditNoteSlice";
import { clearItemList } from "../Item/itemSlice";
// import { TextBox } from "@progress/kendo-react-inputs";
// import { filterClearIcon } from "@progress/kendo-svg-icons";
// import _debounce from "lodash/debounce";

const CreditNote: React.FC = () => {
  const navigate = useNavigate();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  const handleCreate = () => {
    navigate("/creditnote/create");
  };

  return (
    <>
      <DeleteCreditNoteDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Sales Return List
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handleCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              {"Add New"}
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <CreditNoteGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const CreditNoteGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const isEditBtnRef = useRef<any>(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);

  const CreditNoteList = useAppSelector(
    (state) => state.creditnote.CreditNoteList
  );
  const loading = useAppSelector((state) => state.creditnote.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterCustomCreditNote = useAppSelector(
    (state) => state.creditnote.FilterCustomCreditNote
  );
  const [expandedRow, setExpandedRow] = React.useState(null);

  useEffect(() => {
    return () => {
      dispatch(clearItemList());
      dispatch(setCurrentPage(0));
      if (!isEditBtnRef.current) {
        dispatch(clearFilterCustomCreditNote());
      }
    };
  }, []);

  useEffect(() => {
    const payload = {
      ...FilterCustomCreditNote,
      financial_year: FINANCIAL_YEAR,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(getAllCreditNote(payload));
  }, [currentPage, pageLimit]);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEdit = (credit_note_guid: any) => {
      navigate("/creditnote/edit", {
        state: { credit_note_guid: credit_note_guid },
      });
    };

    const handleOpenDeleteDialog = (credit_note_guid: any) => {
      dispatch(openDialog("deleteCreditNote"));
      dispatch(setCreditNoteID(credit_note_guid));
    };
    const handleCreditNotePrint = (credit_note_guid: any) => {
      window.open(`/creditnoteprint/${credit_note_guid}`);
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            ref={isEditBtnRef}
            onClick={() => {
              isEditBtnRef.current = true;
              handleEdit(props.dataItem?.credit_note_guid);
            }}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            onClick={() =>
              handleOpenDeleteDialog(props.dataItem?.credit_note_guid)
            }
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
        {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="View"
            onClick={() =>
              handleCreditNotePrint(props.dataItem?.credit_note_guid)
            }
          >
            <MdPrint
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 7 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const truncateRemarks = (remarks: string) => {
    if (!remarks) return "";
    const maxLength = 100;
    if (remarks.length <= maxLength) return remarks;
    return remarks.substring(0, maxLength) + "...";
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 152px)" }}
        className="responsive-table"
        filterable={true}
        filter={filter}
        data={filter ? filterBy(CreditNoteList, filter) : CreditNoteList}
        onFilterChange={handleFilterChange}
        total={CreditNoteList[0]?.itemcount || CreditNoteList?.length}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="credit_note_no_string"
          title="Sales Return No"
          width={150}
          cell={(props: any) => (
            <td>
              <div
                className={isEditAccess ? "hoverableName" : "normalName"}
                onClick={() =>
                  isEditAccess &&
                  navigate("/creditnote/edit", {
                    state: {
                      credit_note_guid: props.dataItem?.credit_note_guid,
                    },
                  })
                }
              >
                {props.dataItem?.credit_note_no_string}
              </div>
            </td>
          )}
        />
        <Column
          field="credit_note_date"
          title="Sales Return Date"
          filterable={false}
          width={180}
        />
        <Column
          field="bill_no"
          title="Bill No"
          filterable={false}
          width={150}
        />
        <Column
          field="bill_date"
          title="Bill Date"
          width={150}
          filterable={false}
        />
        <Column
          field="gst"
          title="Total GST"
          width={150}
          cell={(props: any) => (
            <td className="text-end">
              {props.dataItem?.gst
                ? formatIndianNumber(props.dataItem?.gst)
                : null}
            </td>
          )}
        />
        <Column
          field="total_amount"
          title="Grand Amount"
          width={150}
          cell={(props: any) => (
            <td className="text-end">
              {props.dataItem?.total_amount
                ? formatIndianNumber(props.dataItem?.total_amount)
                : null}
            </td>
          )}
        />
        <Column
          field="remarks"
          title="Remarks"
          width={200}
          cell={(props: any) => (
            <td>
              <div
                className="remarks-content"
                dangerouslySetInnerHTML={{
                  __html:
                    expandedRow === props.dataItem?.id
                      ? props.dataItem?.remarks
                      : truncateRemarks(props.dataItem?.remarks),
                }}
              />
              {props.dataItem?.remarks.length > 100 && (
                <span
                  className="readmore-btn"
                  onClick={() =>
                    setExpandedRow(
                      expandedRow === props.dataItem?.id
                        ? null
                        : props.dataItem?.id
                    )
                  }
                >
                  {expandedRow === props.dataItem?.id
                    ? "Read Less"
                    : "Read More"}
                </span>
              )}
            </td>
          )}
        />
        {(isEditAccess || isDeleteAccess || isPrintAccess) && (
          <Column
            field="id"
            title="Actions"
            cell={MyEditCommandCell}
            width={"150px"}
            locked={true}
            filterable={false}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeleteCreditNoteDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const CreditNoteID = useAppSelector((state) => state.creditnote.CreditNoteID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterCustomCreditNote = useAppSelector(
    (state) => state.creditnote.FilterCustomCreditNote
  );

  const handleDeleteAction = async (ID: any) => {
    if (ID) {
      const response = await dispatch(deleteCreditNote(ID));
      dispatch(setCurrentPage(0));
      const payload = {
        ...FilterCustomCreditNote,
        financial_year: FINANCIAL_YEAR,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload.Data.Status === 200) {
        dispatch(getAllCreditNote(payload));
        dispatch(closeDialog());
        dispatch(clearCreditNoteID());
      } else {
        dispatch(getAllCreditNote(payload));
        dispatch(closeDialog());
        dispatch(clearCreditNoteID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteCreditNote" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Sales Return"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Sales Return?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(CreditNoteID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

// const CommonFilterCell = (props: any) => {
//   const dispatch = useAppDispatch();
//   const currentPage = useAppSelector((state) => state.pagination.currentPage);
//   const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
//   const FilterCustomCreditNote: any = useAppSelector(
//     (state) => state.creditnote.FilterCustomCreditNote
//   );
//   const isFilterRef = useRef(true);
//   const [inputValue, setInputValue] = useState(props.value || "");
//   const [inputField, setInputField] = useState(props.field || "");

//   const onChange = (event: any) => {
//     setInputValue(event.target.value);
//     setInputField(event.target.name);
//   };

//   const delayedApiCall = React.useCallback(
//     _debounce((updatedFilters: any) => {
//       dispatch(setCurrentPage(0));
//       const payload = {
//         ...updatedFilters,
//         financial_year: FINANCIAL_YEAR,
//         limit: +pageLimit,
//         skip: 0 * +pageLimit,
//       };

//       dispatch(getAllCreditNote(payload));
//     }, 300),
//     [dispatch]
//   );

//   useEffect(() => {
//     if (!isFilterRef.current) {
//       const updatedFilters = {
//         ...FilterCustomCreditNote,
//         [inputField]: inputValue,
//       };
//       dispatch(setFilterCustomCreditNote(updatedFilters));
//       delayedApiCall(updatedFilters);
//     } else {
//       isFilterRef.current = false;
//     }
//     return () => {
//       delayedApiCall.cancel();
//     };
//   }, [inputValue, delayedApiCall]);

//   const onClearButtonClick = (event: any) => {
//     event.preventDefault();
//     props.onChange({
//       value: null,
//       operator: "",
//       syntheticEvent: event,
//     });

//     const updatedFilters = { ...FilterCustomCreditNote, [props.field]: "" };
//     dispatch(setFilterCustomCreditNote(updatedFilters));

//     const payload = {
//       ...updatedFilters,
//       financial_year: FINANCIAL_YEAR,
//       limit: +pageLimit,
//       skip: +currentPage * +pageLimit,
//     };

//     dispatch(getAllCreditNote(payload));
//   };

//   return (
//     <div className="d-flex">
//       <TextBox
//         value={FilterCustomCreditNote[props.field] || ""}
//         name={props.field || ""}
//         onChange={onChange}
//       />
//       <Button
//         svgIcon={filterClearIcon}
//         title="Clear"
//         disabled={!FilterCustomCreditNote[props.field]}
//         onClick={onClearButtonClick}
//         type="button"
//         style={{
//           marginLeft: "8px",
//         }}
//       ></Button>
//     </div>
//   );
// };

export default CreditNote;
